import { lazy } from "react";

// AUTH SCREENS
// Login/MFA/confirmação de e-mail-telefone/recuperação de senha migraram pro
// myplat-sso-web-vite (ver src/utils/sso.js) — só ficam aqui a tela de tenant
// (lógica própria: agrupamento owner/personalização + modal de versão do Maker)
// e as telas de registro (fluxo/campos diferentes do genérico do SSO).
const TenantContainer = lazy(() => import("../screens/Auth/TenantScreen"));
const RegisterContainer = lazy(() => import("../screens/Auth/RegisterScreen"));
const RegisterUserContainer = lazy(() =>
  import("../screens/Auth/RegisterUserScreen")
);
const RegisterCompanyContainer = lazy(() =>
  import("../screens/Auth/RegisterCompanyScreen")
);

// GENERAL SCREENS
const MainScreenContainer = lazy(() => import("../screens/MainScreen"));
const ComponentsEditionContainer = lazy(() =>
  import("../screens/ComponentsEdition")
);
const ParameterCreateEdit = lazy(() =>
  import("../screens/Parameter/ParameterCreateEdit")
);
const ParameterListContainer = lazy(() => import("../screens/Parameter"));
const NewEntityTableContainer = lazy(() => import("../components/EntityModal/NewEntityTable"));
const NewEntityViewContainer = lazy(() => import("../components/EntityModal/NewEntityView"));
const NewEntityViewCommandContainer = lazy(() => import("../components/EntityModal/NewEntityViewCommand"));
const NewEntityProcedureContainer = lazy(() => import("../components/EntityModal/NewEntityProcedure"));
const UsuarioContainer = lazy(() => import("../screens/Usuario"));
const UsuarioListContainer = lazy(() =>
  import("../screens/Usuario/UsuarioList")
);
const ParameterConfig = lazy(() => import("../screens/ParameterConfig"));
const DetailByEntity = lazy(() => import("../screens/DetailByEntity"));
const SendXml = lazy(() => import("../screens/SendXml"));
const FormatReportContainer = lazy(() => import("../screens/formatReport"));
const ReportsListContainer = lazy(() => import("../screens/ReportsList"));
const TypeEdition = lazy(() => import("../screens/TypeEdition"));
const Wizard = lazy(() => import("../screens/Wizard"));
const JsonEditor = lazy(() => import("../screens/JsonEditor"));
const Maker = lazy(() => import("../screens/Maker"));
const PublishVersion = lazy(() => import("../screens/PublishVersion"));
const VersionUpdate = lazy(() => import("../screens/VersionUpdate"));
const SqlIde = lazy(() => import("../screens/SqlIde"));
const SqlIdeExample = lazy(() => import("../screens/SqlIdeExample"));
const NotFound = lazy(() => import("../screens/NotFound"));
const MakerDocs = lazy(() => import("../screens/MakerDocs"));
const AdminModulosMenus = lazy(() => import("../screens/AdminModulosMenus"));
const AdminSistemas = lazy(() => import("../screens/AdminSistemas"));
const AdminTenants = lazy(() => import("../screens/AdminTenants"));
const SystemAccounts = lazy(() => import("../screens/SystemAccounts"));
const ConferenciaNfse = lazy(() => import("../screens/ConferenciaNfse"));
const MonitorIntegracoes = lazy(() => import("../screens/MonitorIntegracoes"));

export const authRoutes = [
  {
    id: "tenant",
    path: "tenant",
    component: <TenantContainer />,
  },
  {
    id: "register",
    path: "/register",
    component: <RegisterContainer />,
  },
  {
    id: "register-user",
    path: "/register-user",
    component: <RegisterUserContainer />,
  },
  {
    id: "register-company",
    path: "/register-company",
    component: <RegisterCompanyContainer />,
  },
];

export const generalRoutes = [
  {
    id: "Maker",
    path: "/maker",
    component: <Maker />,
    hideMenu: false,
    title: "🎨 Maker - Centro de Criação",
    subtitle: "Crie e edite views, entidades, scripts, relatórios e diagramas em um só lugar"
  },
  {
    id: "MainScreen",
    path: "/home",
    component: <Maker />,
    hideMenu: false,
  },
  // {
  //   id: "MainScreen",
  //   path: "/home/:screen",
  //   component: <MainScreenContainer />,
  //   hideMenu: false,
  //},
  {
    id: "ComponentsEdition",
    path: "/listComponentes",
    component: <ComponentsEditionContainer />,
    hideMenu: true,
  },
  {
    id: "ParameterCreateEdit",
    path: "/parameterCreateEdit",
    component: <ParameterCreateEdit />,
    hideMenu: false,
  },
  {
    id: "ParameterList",
    path: "/parameterList",
    component: <ParameterListContainer />,
    hideMenu: false,
  },
  {
    id: "NewEntityTable",
    path: "/entity/new/table",
    component: <NewEntityTableContainer />,
    hideMenu: false,
  },
  {
    id: "NewEntityView",
    path: "/entity/new/view",
    component: <NewEntityViewContainer />,
    hideMenu: false,
  },
  {
    id: "NewEntityViewCommand",
    path: "/entity/new/view-command",
    component: <NewEntityViewCommandContainer />,
    hideMenu: false,
  },
  {
    id: "NewEntityProcedure",
    path: "/entity/new/procedure",
    component: <NewEntityProcedureContainer />,
    hideMenu: false,
  },
  {
    id: "NewEntityTableEdit",
    path: "/entity/edit/table/:entityName",
    component: <NewEntityTableContainer />,
    hideMenu: false,
  },
  {
    id: "NewEntityViewEdit",
    path: "/entity/edit/view/:entityName",
    component: <NewEntityViewContainer />,
    hideMenu: false,
  },
  {
    id: "NewEntityViewCommandEdit",
    path: "/entity/edit/view-command/:entityName",
    component: <NewEntityViewCommandContainer />,
    hideMenu: false,
  },
  {
    id: "NewEntityProcedureEdit",
    path: "/entity/edit/procedure/:entityName",
    component: <NewEntityProcedureContainer />,
    hideMenu: false,
  },
  {
    id: "Usuario",
    path: "/usuario",
    component: <UsuarioContainer />,
    hideMenu: false,
  },
  {
    id: "UsuarioList",
    path: "/usuarioList",
    component: <UsuarioListContainer />,
    hideMenu: false,
  },
  {
    id: "parameterConfig",
    path: "/parameterConfig",
    component: <ParameterConfig />,
  },
  {
    id: "detailByEntity",
    path: "/detailByEntity/:entity",
    component: <DetailByEntity />,
  },
  {
    id: "sendXml",
    path: "/sendXml",
    component: <SendXml />,
  },
  {
    id: "formatReport",
    path: "/formatReport",
    component: <FormatReportContainer />,
    // force the app menu into 'Escondido' when entering this route
    forceMenuState: 'hidden',
  },
  {
    id: "reportsList",
    path: "/reports",
    component: <ReportsListContainer />,
  },
  {
    id: "typeEdition",
    path: "/typeEdition",
    component: <TypeEdition />,
  },
  {
    id: "wizard",
    path: "/wizard",
    component: <Wizard />,
  },
  {
    id: "jsonEditor",
    path: "/json-editor",
    component: <JsonEditor />,
    hideMenu: true,
  },
  {
    id: "publishVersion",
    path: "/publish-version",
    component: <PublishVersion />,
    hideMenu: false,
  },
  {
    id: "versionUpdate",
    path: "/version-update",
    component: <VersionUpdate />,
    hideMenu: false,
  },
  {
    id: "sqlIde",
    path: "/sql-ide",
    component: <SqlIde />,
    hideMenu: false,
    title: "🗄️ SQL IDE",
    subtitle: "Execute consultas SQL e explore suas entidades"
  },
  {
    id: "sqlIdeExample",
    path: "/sql-ide-example",
    component: <SqlIdeExample />,
    hideMenu: false,
    title: "📖 SQL IDE - Exemplos",
    subtitle: "Exemplos de uso do SQL IDE"
  },
  {
    id: "makerDocs",
    path: "/maker/docs",
    component: <MakerDocs />,
    hideMenu: true,
    title: "📖 Documentação Maker",
    subtitle: "Referência completa de todos os componentes e padrões do sistema"
  },
  {
    id: "adminSistemas",
    path: "/admin-sistemas",
    component: <AdminSistemas />,
    hideMenu: false,
    title: "⚙️ Sistemas",
    subtitle: "Gerencie os sistemas cadastrados no SSO",
  },
  {
    id: "adminModulosMenus",
    path: "/admin-modulos-menus",
    component: <AdminModulosMenus />,
    hideMenu: false,
    title: "🧩 Módulos & Menus",
    subtitle: "Gerencie módulos do sistema e vincule itens de menu",
  },
  {
    id: "adminTenants",
    path: "/admin-tenants",
    component: <AdminTenants />,
    hideMenu: false,
    title: "🏢 Tenants",
    subtitle: "Gerencie os tenants e seus módulos",
  },
  {
    id: "systemAccounts",
    path: "/system-accounts",
    component: <SystemAccounts />,
    hideMenu: false,
    title: "🔑 Contas de sistema",
    subtitle: "Client credentials para sistemas que consomem a plataforma (SSO)",
  },
  {
    id: "conferenciaNfse",
    path: "/conferencia-nfse",
    component: <ConferenciaNfse />,
    hideMenu: false,
    title: "🧾 Conferência NFS-e",
    subtitle: "NFS-e autorizadas: valores do sistema x valores calculados pela Sefin, por tenant",
  },
  {
    id: "monitorIntegracoes",
    path: "/monitor-integracoes",
    component: <MonitorIntegracoes />,
    hideMenu: false,
    title: "📡 Monitor de integrações",
    subtitle: "Saúde dos serviços e integrações de hoje (DF-e, NFS-e e banco), todos os tenants, a cada 30 s",
  },
  {
    id: "notFound",
    path: "*",
    component: <NotFound />,
    hideMenu: false,
  },
];

export const allRoutes = [...authRoutes, ...generalRoutes];
